import React, { FC } from 'react';

import { Stack } from '@chakra-ui/react';
import { useFlags } from '@flagsmith/flagsmith/react';
import { useSelector } from 'react-redux';

import { featureFlags, isFeatureEnabled } from 'app/flagsmith/features';
import { selectUser } from 'containers/App/selectors';
import { ConfigureAccountSync } from 'containers/Settings/Components/OrganizationConfig/ConfigureAccountSync';
import { SLASetting } from 'containers/Settings/Components/OrganizationConfig/SLASetting';
import { renderOrgName } from 'containers/Settings/Components/OrganizationConfig/utils';

import { TwoFactorPolicy } from './TwoFactorPolicy';

export const OrganizationConfig: FC = () => {
  const { info } = useSelector(selectUser);
  // Roll out tenant MFA controls with the same flag as self-service enrollment.
  const flags = useFlags([featureFlags.mfa]);

  return (
    <Stack spacing={5} w={'1000px'} h={'full'}>
      {renderOrgName(info?.organization ?? '')}
      {info?.organization !== 'master' &&
        isFeatureEnabled(flags[featureFlags.mfa]) && <TwoFactorPolicy />}
      <ConfigureAccountSync />
      <SLASetting />
    </Stack>
  );
};
